import {Button} from "./Button"

export const WhatsAppButtonStyles = {
    Button: Button
}